import getMessagesForNamespaces from "@lib/i18n/getMessagesForNamespaces";
import GiftCardInformationsView from "@components/views/GiftCards/GiftCardInformations";

const GiftCardInformations = ({ amount }) => (
  <GiftCardInformationsView
    amount={amount}
    standardGiftCard
  />
);

export async function getServerSideProps({ params: { locale }, query }) {
  const { amount } = query;

  if (amount < 25) {
    return {
      redirect: {
        destination: "/buy_gift_cards",
        permanent: false,
      },
    };
  }

  return {
    props: {
      amount,
      headerBehaviors: { noFooter: true, noNavbar: true },
      ...(await getMessagesForNamespaces(locale, ["common", "gift_cards", "stripe"])),
    },
  };
}

GiftCardInformations.requireAuth = false;

export default GiftCardInformations;
